import {
    ReactElement,
    useEffect,
} from 'react';

import {Stack,} from '@mantine/core';

import {useDomainNames} from '../hooks/useDomainNames';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useDomainNamesSelection} from '../hooks/useDomainNamesSelection';
import {DomainName,} from '../types';
import {useParams} from "react-router-dom";
import {useAuth} from "../../../hooks/useAuth.ts";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {DataTableColumn} from 'mantine-datatable';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useMediaQuery} from '@mantine/hooks';

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {id: registrarId} = useParams();

    const {
        user
    } = useAuth();


    if (!user) {
        throw new Error('user is required parameter')
    }


    const {
        visibleItems: records,
        columns,
        page,
        limit,
        loading,
        visibleCount,
        fetchRecords,
        handleFilterByKeyword,
        handleItemsPerPageChange,
        handlePageChange,
    } = useDomainNames(registrarId);


    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = useDomainNamesSelection();

    useEffect(() => {
        fetchRecords();
        // FNP-960: deliberately mount-only. The callback is recreated on
        // every render, so adding it to the deps would re-fire in a loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const smallScreen = useMediaQuery('(max-width: 600px)');

    let filteredColumns = columns;
    if (smallScreen) {
        filteredColumns = columns.filter(item => !['created', 'registrarId', 'category', 'tldId'].includes(item.accessor))
    }

    let selectedRecords = [] as DomainName[];
    if (allowedActions.includes(rbacActions.DeleteDomainName)) {
        selectedRecords = Object.keys(selection)
                                .map(key => selection[key])
    }


    return (
        <Stack gap='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={handleItemsPerPageChange}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={filteredColumns as DataTableColumn[]}
                records={records}
                totalRecords={visibleCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection(item as unknown as DomainName)
                    })
                }}
                fetching={loading}
            />

        </Stack>
    );
};
